/**
 * Defines the available layouts for page metadata.
 */
export enum MetaLayout {
  /** No wrapper or margins */
  Blank = 'blank',

  /** Layout with margins around the content */
  Margin = 'BlankWithMargins',

  /** Default layout settings */
  Default = 'default',

  /** Full-height AI workspace with the app navigation rail */
  AiWorkspace = 'ai-workspace',
}
